import TrustBox from './Trustpilot'

const OfficialTrustpilotReviewsHolder = () => {
  return (
    <div className='mx-auto mb-40 max-w-[1440px] px-16 md:mb-60'>
      <div className='md:hidden flex justify-center'>
        <div className='w-full max-w-[420px] overflow-hidden rounded-[18px] border border-[#EEF2EE] bg-white p-8 shadow-[0px_16px_40px_0px_rgba(0,0,0,0.10)] transition-shadow duration-200'>
          <div className='overflow-hidden rounded-[14px] bg-white'>
            <TrustBox
              templateId='539ad0ffdec7e10e686debd7'
              height='315px'
            />
          </div>
        </div>
      </div>

      <div className='hidden justify-center md:flex'>
        <div className='w-full max-w-[1040px] overflow-hidden rounded-[18px] border border-[#EEF2EE] bg-white p-16 shadow-[0px_18px_48px_0px_rgba(0,0,0,0.10)] transition-shadow duration-200 lg:p-20'>
          <div className='overflow-hidden rounded-[14px] bg-white'>
            <TrustBox
              templateId='539ad0ffdec7e10e686debd7'
              height='360px'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default OfficialTrustpilotReviewsHolder